import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid place-items-center min-h-screen max-h-full overflow-scroll" }
const _hoisted_2 = { class: "max-w-card w-full" }

import RoundedCard from "./RoundedCard.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CenteredCard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(RoundedCard, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ])
  ]))
}
}

})